import {
  EntityType,
  MigrationRunStatus,
  TargetEnvironment,
  type RunView,
} from "../../generated/core-api";

/**
 * LADR-039 D-2: `POST …/runs` returns 409 when a prior run already succeeded
 * for the same `(target_environment, entity_type)`. Pay-component re-import
 * (#212) must stop after validation/dry-run and surface row errors instead of
 * attempting a second push on the same workload.
 */
export function workloadHasSucceededPayComponentsRun(
  runs: RunView[],
  targetEnvironment: TargetEnvironment,
): boolean {
  return runs.some(
    (run) =>
      run.status === MigrationRunStatus.succeeded &&
      run.target_environment === targetEnvironment &&
      run.entity_types.includes(EntityType.pay_components),
  );
}
